import Vue from 'vue'
import Router from 'vue-router'

import AuthService from '../services/auth.service'
import i18n from '../i18n'
import LoginPage from '../components/LoginPage'
import DocumentSelectionPage from '../components/DocumentSelectionPage'
import ModuleMaterialTypesPage from '../components/ModuleMaterialTypesPage'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      title: i18n.t('Kirjaudu sisään'),
      component: LoginPage
    },
    {
      path: '/document',
      name: 'module-material-types',
      title: i18n.t('Dokumentit'),
      component: ModuleMaterialTypesPage
    },
    {
      path: '/document/:materialType/:language',
      name: 'document-selection',
      component: DocumentSelectionPage
    },
    // Otherwise redirect to document list
    {
      path: '*',
      redirect: { name: 'module-material-types' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)

  AuthService.isLoggedIn()
    .then(account => {
      store.commit('account/loginSuccess', account)
      return next()
    })
    .catch(() => {
      // Redirect to login page if not logged in and trying to access a restricted page
      if (authRequired) {
        return next('/login')
      } else {
        return next()
      }
    })
})

router.afterEach((to, from) => {
  // Build nav bar for the route
  store.commit('navigation/changedRoute', to)
})

export default router
